const FETCH_PAYROLL_STARTED = "FETCH_PAYROLL_STARTED";
const FETCH_PAYROLL_SUCCEEDED = "FETCH_PAYROLL_SUCCEEDED";
const FETCH_PAYROLL_FAILED = "FETCH_PAYROLL_FAILED";
const PAYROLL_CONFIRM_CONSENT_STARTED = "PAYROLL_CONFIRM_CONSENT_STARTED";
const PAYROLL_CONFIRM_CONSENT_SUCCEEDED = "PAYROLL_CONFIRM_CONSENT_SUCCEEDED";
const PAYROLL_CONFIRM_CONSENT_FAILED = "PAYROLL_CONFIRM_CONSENT_FAILED";
const UPDATE_CONSENT_DATA = "UPDATE_CONSENT_DATA";

export {
    FETCH_PAYROLL_STARTED,
    FETCH_PAYROLL_SUCCEEDED,
    FETCH_PAYROLL_FAILED,
    PAYROLL_CONFIRM_CONSENT_STARTED,
    PAYROLL_CONFIRM_CONSENT_SUCCEEDED,
    PAYROLL_CONFIRM_CONSENT_FAILED,
    UPDATE_CONSENT_DATA
};
